import { render, staticRenderFns } from "./DashboardBSS.vue?vue&type=template&id=6918b9f0&"
import script from "./DashboardBSS.vue?vue&type=script&lang=js&"
export * from "./DashboardBSS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBSS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports